// Reference data for planogram template management

// Business activities
export const MOCK_BUSINESS_ACTIVITIES = [
  'Quarterly Adjustment',
  'Monthly Adjustment',
  'Bi-weekly Adjustment',
  'New Product Launch',
  'Promotional Activity',
  'Festival Display',
  'Inventory Clearance',
  'Category Optimization',
  'Space Restructuring',
  'Brand Upgrade',
  'Supplier Change',
  'Price Adjustment',
  'Competitor Response',
  'Market Expansion',
  'Customer Feedback Optimization'
];

// Creator/User data
export const MOCK_CREATORS = [
  {
    id: 'U001',
    name: 'John Smith',
    department: 'Display Department',
    role: 'Display Manager',
    email: 'john.smith@company.com'
  },
  {
    id: 'U002',
    name: 'Mary Johnson',
    department: 'Display Department',
    role: 'Senior Display Specialist',
    email: 'mary.johnson@company.com'
  },
  {
    id: 'U003',
    name: 'David Wilson',
    department: 'Operations Department',
    role: 'Operations Director',
    email: 'david.wilson@company.com'
  },
  {
    id: 'U004',
    name: 'Sarah Brown',
    department: 'Procurement Department',
    role: 'Procurement Manager',
    email: 'sarah.brown@company.com'
  },
  {
    id: 'U005',
    name: 'Michael Davis',
    department: 'Marketing Department',
    role: 'Marketing Manager',
    email: 'michael.davis@company.com'
  },
  {
    id: 'U006',
    name: 'Lisa Miller',
    department: 'Training Department',
    role: 'Training Supervisor',
    email: 'lisa.miller@company.com'
  },
  {
    id: 'U007',
    name: 'James Taylor',
    department: 'Visual Department',
    role: 'Visual Designer',
    email: 'james.taylor@company.com'
  },
  {
    id: 'U008',
    name: 'Emma Anderson',
    department: 'Engineering Department',
    role: 'Construction Manager',
    email: 'emma.anderson@company.com'
  }
];

// Regions data
export const MOCK_REGIONS = [
  {
    id: 'R001',
    code: 'EAST',
    name: 'East China',
    description: 'East China region includes Shanghai, Jiangsu, Zhejiang, Anhui, Fujian, Jiangxi, Shandong',
    storeCount: 450
  },
  {
    id: 'R002',
    code: 'SOUTH',
    name: 'South China',
    description: 'South China region includes Guangdong, Guangxi, Hainan, Hong Kong, Macau',
    storeCount: 380
  },
  {
    id: 'R003',
    code: 'NORTH',
    name: 'North China',
    description: 'North China region includes Beijing, Tianjin, Hebei, Shanxi, Inner Mongolia',
    storeCount: 320
  },
  {
    id: 'R004',
    code: 'WEST',
    name: 'Western China',
    description: 'Western China region includes Sichuan, Chongqing, Yunnan, Guizhou, Tibet, Shaanxi, Gansu, Qinghai, Ningxia, Xinjiang',
    storeCount: 280
  },
  {
    id: 'R005',
    code: 'CENTRAL',
    name: 'Central China',
    description: 'Central China region includes Hubei, Hunan, Henan',
    storeCount: 220
  }
];

// Store types data
export const MOCK_STORE_TYPES = [
  {
    id: 'ST001',
    code: 'FLAGSHIP',
    name: 'Flagship Store',
    description: 'Brand image store, located in core business districts, large area, comprehensive product range',
    minArea: 1000,
    maxArea: 3000,
    avgArea: 1800
  },
  {
    id: 'ST002',
    code: 'STANDARD',
    name: 'Standard Store',
    description: 'Standard retail store, located in business districts, moderate area, rich product variety',
    minArea: 300,
    maxArea: 1000,
    avgArea: 600
  },
  {
    id: 'ST003',
    code: 'COMMUNITY',
    name: 'Community Store',
    description: 'Community convenience store, located in residential areas, small area, mainly daily necessities',
    minArea: 100,
    maxArea: 300,
    avgArea: 200
  },
  {
    id: 'ST004',
    code: 'PREMIUM',
    name: 'Premium Store',
    description: 'High-end store, located in upscale business districts, products mainly high-end brands',
    minArea: 500,
    maxArea: 2000,
    avgArea: 1200
  },
  {
    id: 'ST005',
    code: 'OUTLET',
    name: 'Outlet Store',
    description: 'Discount store, located in suburbs or commercial complexes, mainly selling discounted products',
    minArea: 800,
    maxArea: 2500,
    avgArea: 1500
  }
];

// Store formats data
export const MOCK_STORE_FORMATS = [
  {
    id: 'SF001',
    code: 'LARGE',
    name: 'Large',
    description: 'Large store, area over 800 square meters',
    minArea: 800,
    maxArea: 3000,
    characteristics: ['Comprehensive product range', 'Comfortable shopping environment', 'Complete service facilities']
  },
  {
    id: 'SF002',
    code: 'MEDIUM',
    name: 'Medium',
    description: 'Medium store, area between 300-800 square meters',
    minArea: 300,
    maxArea: 800,
    characteristics: ['Rich product variety', 'Compact layout', 'High operational efficiency']
  },
  {
    id: 'SF003',
    code: 'SMALL',
    name: 'Small',
    description: 'Small store, area between 100-300 square meters',
    minArea: 100,
    maxArea: 300,
    characteristics: ['Curated products', 'Quick shopping', 'Convenient services']
  },
  {
    id: 'SF004',
    code: 'MINI',
    name: 'Mini',
    description: 'Mini store, area less than 100 square meters',
    minArea: 20,
    maxArea: 100,
    characteristics: ['Streamlined products', 'Grab and go', '24-hour operation']
  }
];

// Template categories with detailed information
export const MOCK_TEMPLATE_CATEGORIES = [
  {
    id: 'TC001',
    code: 'MAJOR_GLOBAL',
    name: 'Major Global Adjustment',
    description: 'Large-scale adjustments involving entire stores or most areas, wide impact scope, long execution cycle',
    characteristics: ['Wide impact scope', 'Long execution cycle', 'High resource investment', 'High risk'],
    applicableScenarios: ['Annual major adjustment', 'Brand upgrade', 'Space restructuring', 'New business model introduction'],
    estimatedDuration: '30-60 days',
    resourceRequirement: 'High'
  },
  {
    id: 'TC002',
    code: 'PROJECT_BASED',
    name: 'Project-based Adjustment',
    description: 'Adjustments for specific projects or activities with clear objectives and timelines',
    characteristics: ['Clear objectives', 'Clear timelines', 'Project-based management', 'Strong controllability'],
    applicableScenarios: ['New product launch', 'Promotional activities', 'Festival displays', 'Supplier changes'],
    estimatedDuration: '15-30 days',
    resourceRequirement: 'Medium'
  },
  {
    id: 'TC003',
    code: 'REGULAR',
    name: 'Regular Adjustment',
    description: 'Regular periodic adjustments to maintain display freshness and rationality',
    characteristics: ['Periodic execution', 'Standardized processes', 'Low risk', 'High efficiency requirements'],
    applicableScenarios: ['Monthly adjustments', 'Quarterly adjustments', 'Inventory optimization', 'Category adjustments'],
    estimatedDuration: '7-15 days',
    resourceRequirement: 'Medium'
  },
  {
    id: 'TC004',
    code: 'MINOR',
    name: 'Minor Adjustment',
    description: 'Local small-scale adjustments with limited impact and simple execution',
    characteristics: ['Small impact scope', 'Simple execution', 'Low cost', 'Quick completion'],
    applicableScenarios: ['Single item adjustment', 'Price changes', 'Position fine-tuning', 'Inventory handling'],
    estimatedDuration: '3-7 days',
    resourceRequirement: 'Low'
  },
  {
    id: 'TC005',
    code: 'SPECIAL',
    name: 'Special Adjustment',
    description: 'Adjustments for special circumstances or special requirements requiring customized handling',
    characteristics: ['Customized handling', 'High flexibility', 'High professional requirements', 'High innovation'],
    applicableScenarios: ['Brand cooperation', 'Thematic activities', 'Experimental displays', 'Competitor response'],
    estimatedDuration: '10-30 days',
    resourceRequirement: 'Medium-High'
  }
];

// Validation rules data
export const MOCK_VALIDATION_RULES = [
  {
    id: 'VR001',
    name: 'Template Code Uniqueness',
    description: 'Template code must be unique in the system',
    category: 'template',
    severity: 'error',
    message: 'Template code already exists, please use another code'
  },
  {
    id: 'VR002',
    name: 'Final Milestone Validation',
    description: 'The last milestone must be Store Task Generation',
    category: 'milestone',
    severity: 'error',
    message: 'The last milestone must be "Store Task Generation"'
  },
  {
    id: 'VR003',
    name: 'Milestone Sequence Continuity',
    description: 'Milestone sequence must be continuous without gaps',
    category: 'milestone',
    severity: 'warning',
    message: 'Milestone sequence is not continuous, please adjust'
  },
  {
    id: 'VR004',
    name: 'Execution Cycle Reasonableness',
    description: 'Execution cycle configuration must be reasonable, not too frequent or sparse',
    category: 'cycle',
    severity: 'warning',
    message: 'Execution cycle configuration may be unreasonable, please confirm'
  },
  {
    id: 'VR005',
    name: 'Impact Scope Validity',
    description: 'Impact scope must contain valid stores',
    category: 'scope',
    severity: 'error',
    message: 'Impact scope contains invalid stores, please reselect'
  }
];

// Export all reference data
export const REFERENCE_DATA = {
  businessActivities: MOCK_BUSINESS_ACTIVITIES,
  creators: MOCK_CREATORS,
  regions: MOCK_REGIONS,
  storeTypes: MOCK_STORE_TYPES,
  formats: MOCK_STORE_FORMATS,
  templateCategories: MOCK_TEMPLATE_CATEGORIES,
  validationRules: MOCK_VALIDATION_RULES
};